import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinamritsar() {



  const cardData =
  {
    keyword: 'Cab Services in Amritsar',
    heading: 'Aaryan Travels: Cab Services in Amritsar',
    headingDescription: ' Aaryan Travels offers reliable Cab Services in Amritsar for local sightseeing, airport transfers, pilgrimage tours, and outstation travel. Whether you are visiting the Golden Temple, Jallianwala Bagh, Wagah Border, or planning trips to nearby cities like Chandigarh, Pathankot, or Jammu, our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and comfortable journey. With professional chauffeurs, transparent pricing, and 24/7 service availability, we provide safe and convenient cab services for families, tourists, and corporate travelers alike. From Amritsar Railway Station to Sri Guru Ram Dass Jee International Airport, Aaryan Travels delivers doorstep pickup and dependable travel solutions across the city.',

    top: 'Top Places to Visit in Amritsar with Aaryan Travels',

"topPlaces": [
  {
    "title": "Golden Temple (Harmandir Sahib)",
    "description": "The Golden Temple is the holiest shrine of Sikhism, renowned for its gold-plated sanctum sitting gracefully in the middle of a sacred lake. Devotees from around the world visit to seek peace and blessings. The divine sound of Gurbani kirtan and the serene reflections in the water create a heavenly atmosphere. The temple's Langar serves free meals to thousands daily, symbolizing equality and service. The Golden Temple is Amritsar’s radiant heart of devotion."
  },
  {
    "title": "Jallianwala Bagh",
    "description": "Jallianwala Bagh is a memorial park dedicated to the martyrs of the 1919 massacre led by British forces. Bullet marks on the walls and the preserved well stand as silent witnesses to the tragic event. The flame-shaped memorial and light-and-sound show evoke deep patriotism. The garden is a powerful reminder of India’s freedom struggle. Jallianwala Bagh is Amritsar’s ground of sacrifice and national pride."
  },
  {
    "title": "Wagah Border Ceremony",
    "description": "Located on the India-Pakistan border, the Wagah Border hosts the daily Beating Retreat Ceremony. Soldiers from both nations perform synchronized drills, energetic marches, and flag-lowering rituals. The roaring cheers of ‘Bharat Mata Ki Jai’ and patriotic music electrify the atmosphere. It is a thrilling spectacle of discipline and unity. Wagah Border is Amritsar’s patriotic power show."
  },
  {
    "title": "Akal Takht",
    "description": "Akal Takht, situated within the Golden Temple complex, is one of the five seats of Sikh authority established by Guru Hargobind Sahib. It stands as a symbol of justice and sovereignty. The structure reflects a fusion of strength and spirituality. Devotees visit to seek guidance and pay respects. Akal Takht is Amritsar’s seat of courage and leadership."
  },
  {
    "title": "Durgiana Temple",
    "description": "Durgiana Temple, also known as the Silver Temple, resembles the Golden Temple in architecture but is dedicated to Goddess Durga. Its holy pond and glowing facade attract both pilgrims and tourists. The intricate silver doors and peaceful ambiance make it spiritually uplifting. Festivals like Navratri are celebrated with grandeur. Durgiana Temple is Amritsar’s divine mirror of devotion."
  },
  {
    "title": "Hall Bazaar",
    "description": "Hall Bazaar is one of Amritsar’s oldest and busiest marketplaces, known for traditional Phulkari embroidery, juttis, spices, and handicrafts. The arched Mughal-style entrance welcomes shopaholics and food lovers alike. Colorful lanes filled with aroma of street snacks like Amritsari kulcha and lassi make the experience unforgettable. Hall Bazaar is Amritsar’s bustling shopping soul."
  },
  {
    "title": "Partition Museum",
    "description": "The Partition Museum documents the emotional and historical journey of India’s 1947 partition. Exhibits include letters, photographs, and personal belongings of refugees who migrated during the divide. Audio-visual stories offer moving insights into resilience and healing. It is an essential stop for understanding India’s past. The Partition Museum is Amritsar’s archive of memories and humanity."
  },
  {
    "title": "Gobindgarh Fort",
    "description": "Gobindgarh Fort is a historic fortress once ruled by Maharaja Ranjit Singh. Now converted into a cultural attraction, it features live folk performances, 7D shows, and traditional food courts. The light-and-sound show narrates Punjab’s valorous past. Visitors enjoy camel rides and weapon displays inside the fort. Gobindgarh Fort is Amritsar’s warrior heritage brought to life."
  },
  {
    "title": "Ram Bagh Gardens & Maharaja Ranjit Singh Museum",
    "description": "Ram Bagh Gardens is a peaceful green expanse once used as the summer palace of Maharaja Ranjit Singh. The museum inside displays royal artifacts, paintings, and weapons. Sculptures and fountains enhance the garden’s charm. It is ideal for leisurely walks and history tours. Ram Bagh is Amritsar’s elegant blend of nature and royalty."
  },
  {
    "title": "Khalsa College",
    "description": "Khalsa College is an architectural marvel built in Indo-Saracenic style, featuring red sandstone domes and arched corridors. Established in 1892, the institution has produced many national leaders and scholars. Its expansive campus and heritage design attract photographers and tourists. The college looks especially stunning at sunrise and sunset. Khalsa College is Amritsar’s pride in education and elegance."
  }
],


"services": [
  {
    "name": "Cab Services in Amritsar",
    "description": "Explore comprehensive cab services in Amritsar designed to cater to all your travel needs. Whether you require a quick city ride or a comfortable outstation journey, our fleet of vehicles is maintained to the highest standards. Experienced drivers ensure safe and timely travel, while competitive pricing and 24/7 availability make your commute hassle-free. From solo travelers to groups, our diverse cab options provide flexible solutions for daily commutes, sightseeing, or business trips within and around Amritsar."
  },
  {
    "name": "Taxi Booking Amritsar",
    "description": "Book your taxi in Amritsar with ease through our user-friendly platforms offering instant confirmations and secure payment options. Our taxi booking service includes a variety of vehicle choices—from budget-friendly hatchbacks to spacious SUVs—ensuring a ride tailored to your specific requirements. Enjoy real-time tracking, professional drivers, and customer support that’s always ready to assist, making your travel planning smooth and stress-free."
  },
  {
    "name": "Local Cabs Amritsar",
    "description": "Local Cabs Amritsar specialize in short-distance travel within the city, providing quick, affordable, and reliable transportation for errands, office commutes, or leisure outings. With prompt pickups and knowledgeable drivers familiar with city routes and traffic patterns, your journey through Amritsar is convenient and comfortable. Vehicles are well-maintained and sanitized, ensuring safety and hygiene for every passenger."
  },
  {
    "name": "Best Taxi Amritsar",
    "description": "Experience the best taxi service in Amritsar, where customer satisfaction and quality are prioritized above all. Our top-rated taxis feature punctuality, professional drivers, and well-kept vehicles to make your travel experience enjoyable and dependable. Whether for airport transfers, corporate travel, or sightseeing, the best taxi service in Amritsar offers competitive rates and exceptional reliability."
  },
  {
    "name": "Amritsar City Taxi",
    "description": "Navigate Amritsar effortlessly with our city taxi service, designed for convenience and comfort. Whether it’s daily office travel, shopping trips, or attending events, our city taxis are available round-the-clock with flexible booking options. Drivers are courteous, and vehicles are equipped with modern amenities to enhance your ride within the city."
  },
  {
    "name": "Outstation Cab Amritsar",
    "description": "Travel beyond city limits confidently with Outstation Cab Amritsar. Ideal for trips to nearby cities or tourist destinations, our service offers comfortable, safe, and reliable cabs for one-way or round trips. Drivers experienced with long-distance routes ensure a smooth journey while you relax and enjoy the ride. Choose from a variety of vehicles to match your travel needs and group size."
  },
  {
    "name": "Affordable Cab Amritsar",
    "description": "Affordable Cab Amritsar provides budget-friendly travel solutions without compromising on quality or safety. Perfect for daily commuters, students, and travelers looking for economical yet reliable rides, this service features transparent pricing, prompt pickups, and vehicles that meet safety and comfort standards. Enjoy cost-effective cab travel around Amritsar with no hidden fees."
  },
  {
    "name": "Premium Taxi Amritsar",
    "description": "For those seeking luxury and style, Premium Taxi Amritsar offers high-end vehicles equipped with advanced amenities and professional chauffeurs. Ideal for business travelers, weddings, or special occasions, this premium service guarantees a sophisticated travel experience. Enjoy the comfort of spacious interiors, air conditioning, and personalized services tailored to your preferences."
  },
  {
    "name": "Online Cab Booking Amritsar",
    "description": "Book your Amritsar cab online with quick and secure platforms that offer easy navigation, instant fare estimates, and multiple payment options. Online Cab Booking Amritsar is designed to save your time and provide flexibility in scheduling rides. With real-time tracking and instant booking confirmation, you can plan your trips confidently from anywhere."
  },
  {
    "name": "Reliable Taxi Amritsar",
    "description": "Reliable Taxi Amritsar focuses on delivering punctual and dependable transportation services throughout the city and beyond. With background-checked drivers, well-maintained vehicles, and a commitment to customer satisfaction, this service ensures you reach your destination safely and on time every time. Whether it's for regular commuting or last-minute travel, rely on us for seamless journeys."
  },
  {
    "name": "24x7 Cab Amritsar",
    "description": "Our 24x7 Cab Amritsar service is available round-the-clock to cater to all your travel needs at any hour. Whether it's early morning airport transfers, late-night rides, or emergency travel, our fleet is always ready with professional drivers ensuring your safety and convenience at all times. Experience hassle-free travel no matter the time of day or night."
  },
  {
    "name": "Airport Taxi Amritsar",
    "description": "Ensure timely and comfortable airport transfers with Airport Taxi Amritsar. Our professional chauffeurs track your flight status to provide punctual pickups and drop-offs, minimizing wait times. Whether you’re arriving or departing, enjoy smooth transit with spacious, clean vehicles equipped for luggage handling and passenger comfort."
  },
  {
    "name": "Sedan Cab Amritsar",
    "description": "Sedan Cab Amritsar offers comfortable rides in air-conditioned sedans, ideal for both business and leisure travel. These vehicles provide a smooth and quiet ride, perfect for airport trips, city tours, or corporate events. With professional drivers and easy booking options, you get a premium yet affordable taxi experience."
  },
  {
    "name": "SUV Rental Amritsar",
    "description": "Travel with extra space and comfort in our SUV Rental Amritsar service, suitable for family trips, group travel, or luggage-heavy journeys. Our SUVs are well-maintained, equipped with modern amenities, and driven by courteous, experienced chauffeurs. Perfect for both city and outstation travel with flexible rental packages to suit your itinerary."
  },
  {
    "name": "Amritsar Cab Near Me",
    "description": "Looking for a cab near you in Amritsar? Our wide network of drivers and vehicles ensures rapid response times no matter your location in the city. With efficient dispatch and real-time tracking, you get a nearby cab that arrives quickly, offering convenience for last-minute travel or planned rides alike."
  }
],
"tableData": [
  ["Cab Services in Amritsar", "Taxi Booking Amritsar"],
  ["Local Cabs Amritsar", "Best Taxi Amritsar"],
  ["Amritsar City Taxi", "Outstation Cab Amritsar"],
  ["Affordable Cab Amritsar", "Premium Taxi Amritsar"],
  ["Online Cab Booking Amritsar", "Reliable Taxi Amritsar"],
  ["24x7 Cab Amritsar", "Airport Taxi Amritsar"],
  ["Sedan Cab Amritsar", "SUV Rental Amritsar"],
  ["Amritsar Cab Near Me", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Services in Amritsar",
    "WhyChoosedescription": "Aaryan Travels offers dependable and timely cab services across Amritsar for all your travel needs."
  },
  {
    "WhyChooseheading": "Prompt and Convenient Pickup Throughout Amritsar",
    "WhyChoosedescription": "Our drivers are always nearby to ensure quick pickups and smooth rides within the city."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for a Pleasant Journey",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs designed to provide comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Amritsar Roads",
    "WhyChoosedescription": "Our professional drivers know the city well to ensure efficient and timely rides."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "Enjoy upfront pricing that covers fuel, tolls, and driver allowances for a hassle-free experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for Local and Outstation Travel",
    "WhyChoosedescription": "Choose from hourly rentals, point-to-point rides, or long-distance journeys as per your needs."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size and Luggage",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your comfort and luggage requirements."
  }
]




























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer cab services in Amritsar?',
    answer: 'Yes, Aaryan Travels provides reliable and convenient cab services across Amritsar, including local rides, airport transfers, and outstation trips.',
  },
  {
    question: 'How can I book a cab in Amritsar with Aaryan Travels?',
    answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of cabs are available for booking in Amritsar?',
    answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
  },
  {
    question: 'Can I book a cab for both local travel and outstation trips from Amritsar?',
    answer: 'Yes, Aaryan Travels provides cab services for local rides as well as outstation trips from Amritsar to various destinations.',
  },
  {
    question: 'Is airport pick-up and drop-off service available in Amritsar?',
    answer: 'Absolutely. We offer timely and dependable airport pick-up and drop-off services to and from Sri Guru Ram Das Jee International Airport.',
  },
  {
    question: 'Are Aaryan Travels’ drivers experienced and familiar with Amritsar routes?',
    answer: 'Yes, all our drivers are professionally trained, licensed, and well-acquainted with Amritsar and surrounding areas to ensure safe and efficient travel.',
  },
  {
    question: 'Is 24x7 cab service available in Amritsar with Aaryan Travels?',
    answer: 'Yes, we operate round-the-clock to cater to your travel requirements at any time of the day or night.',
  },
  {
    question: 'What safety protocols are followed for cab services in Amritsar?',
    answer: 'Our vehicles are sanitized regularly, and our drivers adhere to strict safety and hygiene protocols to ensure passenger safety.',
  },
  {
    question: 'What payment options does Aaryan Travels accept for cab services in Amritsar?',
    answer: 'We accept cash, credit/debit cards, UPI, and major digital wallets for your convenience.',
  },
  {
    question: 'Can I customize pickup and drop-off locations within Amritsar?',
    answer: 'Yes, you can specify your preferred pickup and drop-off points within Amritsar as per your travel plans.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harpreet Singh',
    feedback: 'Aaryan Travels provided excellent cab service during my trip to Amritsar. The driver was punctual, professional, and the vehicle was clean and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Simran Kaur',
    feedback: 'I had a wonderful experience with Aaryan Travels. The booking process was smooth, and the driver was knowledgeable about the local attractions.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Services in Amritsar",
  "image": "https://aaryantravels.com/assets/images/cab-services-amritsar.jpg", // replace with actual image URL
  "description": "Reliable and affordable cab services in Amritsar by Aaryan Travels. Book local, outstation, sedan, SUV, and airport taxis online with professional drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6",  // example rating, update if needed
    "ratingCount": "1500", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "900",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/cab-services-amritsar"
  }
};






  return (
    <div>


<Helmet>
  <title>Cab Services in Amritsar | Reliable & Affordable Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable cab services in Amritsar by Aaryan Travels. Book local, outstation, sedan, SUV, and airport taxis online with professional drivers available 24x7."
  />
  <meta
    name="keywords"
    content="Cab Services in Amritsar, Taxi Booking Amritsar, Local Cabs Amritsar, Best Taxi Amritsar, Amritsar City Taxi, Outstation Cab Amritsar, Affordable Cab Amritsar, Premium Taxi Amritsar, Online Cab Booking Amritsar, Reliable Taxi Amritsar, 24x7 Cab Amritsar, Airport Taxi Amritsar, Sedan Cab Amritsar, SUV Rental Amritsar, Amritsar Cab Near Me"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinamritsar;